import { render, staticRenderFns } from "./CommunityPost.vue?vue&type=template&id=0521dc93"
import script from "./CommunityPost.vue?vue&type=script&lang=js"
export * from "./CommunityPost.vue?vue&type=script&lang=js"
import style0 from "./CommunityPost.vue?vue&type=style&index=0&id=0521dc93&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports